import React from 'react';
import locales from '../../../../../content.json';
import s from './index.module.scss';
import { useDigitalProductPriceV2 } from '../price/useDigitalProductPrice';

export const PriceV2 = () => {
  const { price, oldPrice, currency } = useDigitalProductPriceV2();

  return (
    <div className={s.wrapper}>
      <p className={s.text}>{locales[window.userLang].pdfUpselling_13}</p>
      <div className={`${s.price} ${currency === 'USD ' ? s.USD : ''}`}>
        <p>-98%</p>
        <p>{currency}{oldPrice}</p>
        <p>{currency}{price}</p>
      </div>
    </div>
  );
};
